mutation CopyCampaign(
    $campaignId: ID!
    $name: String!
    $masterTemplateIds: [ID!]!
    $languages: [String!]!
    $sectionId: ID
) {
    copyCampaign(
        campaignId: $campaignId
        name: $name
        masterTemplateIds: $masterTemplateIds
        languages: $languages
        sectionId: $sectionId
    ) {
        _id
    }
}
